export default __webpack_public_path__ + "img/bus-stop.e8fd110d.png";